<template>
  <div class="background-main">
    <div class="sidepanel-wrapper d-flex h-100 flex-three">
      <div class="sidepanel"  :class="[isCollapsed ? 'isCollapsed' : '']">
        <div class="container-fluid">
          <div class="row">
            <div class="logo">
            <img src="../../src/assets/avicennaLogo.svg" alt="Logo" />
            <button class="toggle" @click="toggleCollapse" v-if="isCollapsed">
              <img src="../assets/doubleChevron.svg" alt="toggle-collapse">
            </button>
            <span class="logo-text" :class="isCollapsed ? 'hide' : ''">Avicenna Hospital</span>
          <button class="toggle" @click="toggleCollapse" :class="isCollapsed ? 'hide' : ''">
            <img src="../assets/doubleChevron.svg" alt="toggle-collapse" class="mirror">
          </button>
        </div>
          </div>
        </div>
          <ul class="menu my-4" :class="[isCollapsed ? 'font-small' : '']">
            <router-link to="/">
              <li class="menu-item" @click="selectTab(0)" :class="selectedTab == 0 ? 'active' : ''">
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'menu-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0)" fill="#C4C4C4"><path d="M11.562 0H2.187A2.19 2.19 0 000 2.187v5.625A2.19 2.19 0 002.187 10h9.375a2.19 2.19 0 002.188-2.188V2.187A2.19 2.19 0 0011.562 0zM11.562 12.5H2.187A2.19 2.19 0 000 14.688v13.125A2.19 2.19 0 002.187 30h9.375a2.19 2.19 0 002.188-2.187V14.688a2.19 2.19 0 00-2.188-2.188zM27.813 20h-9.375a2.19 2.19 0 00-2.188 2.188v5.625A2.19 2.19 0 0018.438 30h9.375A2.19 2.19 0 0030 27.813v-5.625A2.19 2.19 0 0027.813 20zM27.813 0h-9.375a2.19 2.19 0 00-2.188 2.187v13.125a2.19 2.19 0 002.188 2.188h9.375A2.19 2.19 0 0030 15.312V2.187A2.19 2.19 0 0027.813 0z"/></g><defs><clipPath id="clip0"><path fill="#fff" d="M0 0h30v30H0z"/></clipPath></defs></svg>
                <span class="menu-item-text">Overview</span>
              </li>
            </router-link>
            <router-link to="/directory">
              <li class="menu-item" @click="selectTab(1)" :class="selectedTab == 1 || patientHeader ? 'active' : ''">
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'menu-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0)" fill="#C4C4C4"><path d="M18.125 30a1.25 1.25 0 01-1.04-.556l-2.129-3.194H12.5a1.25 1.25 0 010-2.5h3.125c.418 0 .808.209 1.04.556l1.305 1.958 2.786-5.574a1.252 1.252 0 012.19-.085l3.386 5.645h2.418a1.25 1.25 0 010 2.5h-3.125c-.439 0-.846-.23-1.071-.606l-2.579-4.297-2.731 5.463c-.2.399-.596.662-1.041.689l-.078.001zM11.25 12.5a6.25 6.25 0 100-12.5 6.25 6.25 0 000 12.5z"/><path d="M8.75 25a3.755 3.755 0 013.75-3.75h3.125c.649 0 1.274.166 1.823.471l1.073-2.148c.546-1.09 1.587-1.803 2.768-1.993C20.15 16.024 18.326 15 16.25 15h-10A6.25 6.25 0 000 21.25v4.063c0 .517.42.937.938.937H8.98c-.14-.392-.23-.81-.23-1.25z"/></g><defs><clipPath id="clip0"><path fill="#C4C4C4" d="M0 0h30v30H0z"/></clipPath></defs></svg>
                <span class="menu-item-text">Patients</span>
              </li>
            </router-link>
            <router-link to="/appointments">
              <li class="menu-item" @click="selectTab(2)" :class="selectedTab == 2 ? 'active' : ''">
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'menu-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M18.523 19.372h-.88v-1.761h2.641a.88.88 0 100-1.762h-3.523a.88.88 0 00-.88.881v3.523c0 .486.394.88.88.88h1.762a.882.882 0 010 1.762H16.76a.88.88 0 000 1.762h1.762a2.645 2.645 0 002.642-2.643 2.645 2.645 0 00-2.642-2.642zM13.239 22.895h-1.982l2.114-2.819a2.645 2.645 0 00-2.115-4.227 2.645 2.645 0 00-2.641 2.643.88.88 0 001.761 0 .882.882 0 111.586.527l-3.171 4.229a.88.88 0 00.704 1.409h3.743a.88.88 0 000-1.762z" fill="#C4C4C4"/><path d="M25.569 3.46h-.88v-.818A2.645 2.645 0 0022.045 0a2.645 2.645 0 00-2.642 2.642v.818h-8.808v-.818A2.645 2.645 0 007.954 0a2.645 2.645 0 00-2.642 2.642v.818h-.88a2.645 2.645 0 00-2.643 2.643v21.255A2.645 2.645 0 004.431 30H25.57a2.645 2.645 0 002.642-2.642V6.103A2.645 2.645 0 0025.57 3.46zm-4.404-.818a.882.882 0 011.762 0v3.523a.882.882 0 01-1.762 0V2.642zm-14.092 0a.882.882 0 011.762 0v3.523a.882.882 0 01-1.762 0V2.642zM26.45 27.358c0 .485-.395.88-.881.88H4.431a.882.882 0 01-.88-.88v-15.09H26.45v15.09zm0-16.852H3.55V6.103c0-.486.396-.881.881-.881h.881v.943a2.645 2.645 0 002.642 2.642 2.645 2.645 0 002.642-2.642v-.943h8.808v.943a2.645 2.645 0 002.642 2.642 2.645 2.645 0 002.642-2.642v-.943h.881c.486 0 .88.395.88.88v4.404z" fill="#C4C4C4"/></svg>
                <span class="menu-item-text">Appointments</span>
              </li>
            </router-link>
            <router-link to="/settings">
              <li class="menu-item" @click="selectTab(3)" :class="selectedTab == 3 ? 'active' : ''">
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'menu-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0)" fill="#C4C4C4"><path d="M18.5 17.5h-.55a.492.492 0 01-.463-.323 8.142 8.142 0 00-.197-.471.493.493 0 01.1-.558l.392-.393a1.504 1.504 0 00-.003-2.12l-1.413-1.412a1.503 1.503 0 00-2.12 0l-.392.391a.495.495 0 01-.557.1c-.155-.07-.312-.136-.473-.2a.492.492 0 01-.324-.464v-.55A1.5 1.5 0 0011 10H9a1.5 1.5 0 00-1.5 1.5v.55a.492.492 0 01-.323.463c-.16.061-.316.127-.471.197a.494.494 0 01-.559-.1l-.392-.392a1.504 1.504 0 00-2.12 0l-1.412 1.418a1.503 1.503 0 000 2.12l.391.392c.148.146.188.369.1.558-.07.154-.136.311-.197.471a.492.492 0 01-.467.323H1.5A1.5 1.5 0 000 19v2a1.5 1.5 0 001.5 1.5h.55c.207 0 .392.129.463.323.061.16.127.317.197.471a.493.493 0 01-.1.558l-.392.393a1.504 1.504 0 000 2.12l1.413 1.413a1.503 1.503 0 002.12 0l.392-.392a.495.495 0 01.558-.1c.155.07.312.136.472.2.196.07.327.256.327.464v.55A1.5 1.5 0 009 30h2a1.5 1.5 0 001.5-1.5v-.55c0-.207.129-.392.323-.463.16-.061.316-.127.471-.197a.494.494 0 01.558.1l.393.392c.587.582 1.534.58 2.12-.003l1.413-1.413a1.503 1.503 0 000-2.12l-.392-.391a.493.493 0 01-.1-.558c.07-.155.136-.312.2-.473a.492.492 0 01.464-.324h.55A1.5 1.5 0 0020 21v-2a1.5 1.5 0 00-1.5-1.5zM19 21a.5.5 0 01-.5.5h-.55a1.505 1.505 0 00-1.4.967c-.053.14-.11.278-.172.414a1.504 1.504 0 00.3 1.677l.391.392a.5.5 0 010 .707l-1.413 1.413a.5.5 0 01-.707 0l-.392-.391a1.503 1.503 0 00-1.678-.3 7.245 7.245 0 01-.412.172c-.58.222-.965.778-.967 1.399v.55a.5.5 0 01-.5.5H9a.5.5 0 01-.5-.5v-.55a1.505 1.505 0 00-.967-1.4 6.903 6.903 0 01-.413-.172 1.505 1.505 0 00-1.679.3l-.391.391a.5.5 0 01-.707 0L2.93 25.657a.5.5 0 010-.706l.391-.393c.438-.443.557-1.11.3-1.677a7.245 7.245 0 01-.172-.413A1.505 1.505 0 002.05 21.5H1.5A.5.5 0 011 21v-2a.5.5 0 01.5-.5h.55a1.505 1.505 0 001.4-.967c.053-.14.11-.278.172-.414a1.505 1.505 0 00-.3-1.678l-.393-.391a.5.5 0 010-.707l1.413-1.413a.5.5 0 01.707 0l.392.391c.443.438 1.11.558 1.678.3.136-.062.274-.119.413-.172.58-.221.965-.777.968-1.399v-.55A.5.5 0 019 11h2a.5.5 0 01.5.5v.55c.002.622.386 1.178.967 1.4.14.053.278.11.413.172a1.503 1.503 0 001.678-.3l.392-.391a.503.503 0 01.708 0l1.412 1.413a.5.5 0 010 .707l-.391.392a1.505 1.505 0 00-.3 1.678c.061.136.119.274.172.413.222.58.778.963 1.399.966h.55a.5.5 0 01.5.5v2z"/><path d="M14.49 19.8a4.516 4.516 0 00-.09-.738c-.017-.082-.04-.162-.062-.243a4.475 4.475 0 00-.17-.511 4.456 4.456 0 00-.221-.468c-.006-.012-.01-.024-.017-.036a4.436 4.436 0 00-.45-.655c-.014-.018-.031-.036-.046-.053a4.184 4.184 0 00-.214-.236 7.415 7.415 0 00-.271-.254 4.717 4.717 0 00-.186-.153l-.082-.061A4.468 4.468 0 0010 15.5c-.05 0-.1.008-.15.01a4.354 4.354 0 00-.491.04 4.578 4.578 0 00-.485.09 4.502 4.502 0 00.004 8.72c.008 0 .016.003.025.005.173.043.348.076.524.1.116.014.233.017.35.023.078.003.15.015.232.015.142 0 .29-.01.441-.024.016 0 .032-.005.05-.007a4.34 4.34 0 00.37-.056c.05-.01.097-.023.145-.034a4.72 4.72 0 00.265-.068c.07-.021.138-.046.207-.07.068-.023.139-.05.21-.076.071-.027.13-.058.195-.088.084-.039.168-.077.25-.122h.003a5.92 5.92 0 001.282-.925c.103-.097.193-.208.268-.329a5.339 5.339 0 00.787-2.346c.007-.09.011-.18.014-.27 0-.029.003-.056.003-.085.001-.07-.006-.135-.009-.203zm-.997.328c0 .041-.003.082-.005.123a3.507 3.507 0 01-1.802 2.814 3.912 3.912 0 01-.184.091l-.042.02a3.61 3.61 0 01-.912.276l-.067.01a3.508 3.508 0 01-.429.035h-.105a3.52 3.52 0 01-.354-.022l-.06-.007a3.5 3.5 0 01-.412-6.858 3.454 3.454 0 011.306-.081l.114.017c.107.017.214.038.32.066l.103.026c.266.077.522.184.762.321l.114.07c.08.05.156.1.232.157.04.029.081.058.12.09.098.078.192.161.281.25.036.035.068.075.103.113a3.472 3.472 0 01.274.337c.05.072.1.146.146.223l.075.124c.065.119.122.241.172.366.02.05.037.1.055.15.033.093.06.186.085.28.013.05.027.094.037.143.03.135.05.271.063.409l.006.11c.007.115.009.23.004.347zM28.5 10.5h-1.573a.488.488 0 01-.465-.328 10.42 10.42 0 00-.562-1.356.49.49 0 01.096-.564l1.115-1.117a1.5 1.5 0 000-2.12l-2.126-2.122a1.5 1.5 0 00-2.12 0L21.75 4.006a.49.49 0 01-.564.096c-.438-.22-.891-.409-1.356-.564a.488.488 0 01-.33-.467V1.5A1.5 1.5 0 0018 0h-3a1.5 1.5 0 00-1.5 1.5v1.572a.488.488 0 01-.328.466 10.42 10.42 0 00-1.356.565.488.488 0 01-.564-.096l-1.117-1.115a1.503 1.503 0 00-2.12 0L5.893 5.013a1.5 1.5 0 000 2.122l1.64 1.642a.5.5 0 00.707-.706L6.6 6.429a.5.5 0 010-.707L8.722 3.6a.5.5 0 01.707 0l1.117 1.115a1.486 1.486 0 001.718.282 9.453 9.453 0 011.226-.51 1.488 1.488 0 001.01-1.415V1.5A.5.5 0 0115 1h3a.5.5 0 01.5.5v1.572c-.003.64.404 1.21 1.01 1.415.42.141.83.311 1.226.51a1.49 1.49 0 001.718-.282L23.571 3.6a.5.5 0 01.707 0L26.4 5.723a.5.5 0 010 .706l-1.115 1.117a1.488 1.488 0 00-.282 1.718c.198.396.369.806.51 1.226a1.487 1.487 0 001.414 1.01H28.5a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1.573a1.487 1.487 0 00-1.414 1.01c-.141.42-.311.83-.51 1.226a1.488 1.488 0 00.282 1.718l1.116 1.117a.5.5 0 010 .707L24.277 23.4a.5.5 0 01-.707 0l-1.643-1.64a.5.5 0 10-.706.708l1.642 1.64a1.5 1.5 0 002.121 0l2.122-2.122a1.5 1.5 0 000-2.12l-1.113-1.116a.49.49 0 01-.097-.564c.22-.438.409-.891.565-1.356a.488.488 0 01.465-.33H28.5A1.5 1.5 0 0030 15v-3a1.5 1.5 0 00-1.5-1.5z"/><path d="M21.096 8.904a6.507 6.507 0 00-9.192 0 .5.5 0 00.707.707 5.5 5.5 0 117.778 7.778.5.5 0 10.707.707 6.506 6.506 0 000-9.192z"/></g><defs><clipPath id="clip0"><path fill="#fff" d="M0 0h30v30H0z"/></clipPath></defs></svg>
                <span class="menu-item-text">Settings</span>
              </li>
            </router-link>
            <li class="menu-item mt-auto" @click="logout">
              <img src="../../src/assets/logout.svg" alt="logout" class="menu-icon" />
              <span class="menu-item-text">Logout</span>
            </li>
          </ul>
        </div>
    </div>
    <div class="main-view-wrapper flex-seven">
      <header>
        <router-link :to="{name: 'add-appointment' }" class="button-link">
          <button class="add-button">
            <img src="../assets/add-appointment.svg" class="button-logo" alt="new-appointment-logo">
            <div class="add-button-text">New Appointment</div>
          </button>
        </router-link>
        <router-link :to="{name: 'add-patient' }" class="button-link">
          <button class="add-button">
            <img src="../assets/add-patient.svg" class="button-logo" alt="new-patient-logo">
            <div class="add-button-text">New Patient</div>
          </button>
        </router-link>
        <div class="user-options">
          <div class="header-profile-pic">
            <img :src="getProfilePic(currentUser)" class="profilePic" id="smallImage">
          </div>
          <div class="header-username">{{currentUser.fullname}}</div>
        </div>
      </header>
      <template v-if="patientHeader">
        <PatientHeader/>
        <LocalTabs />
      </template>
      <div class="main-view">
        <div class="padding-sides" :class="[patientHeader ?'change-height' : '']">
          <router-view />
        </div>
        <div class="mask" :class="[patientHeader ? 'change-height' : '', isCollapsed ? 'change-width' : '']"></div>
        <div class="toast-container" ></div>
      </div>
    </div>
  </div>
</template>

<script>
import PatientHeader from './PatientHeader.vue'
import LocalTabs from '../components/LocalTabs.vue'
import { mapState, mapActions } from 'vuex'
import { defaultPic, publicAssetUrl } from '../util/util'

import axios from 'axios'
export default {
  name: 'Layout',
  components: { PatientHeader, LocalTabs },
  data() {
    return {
      pageNames: ['mainPage', 'directory', 'appointments', 'settings'],
      selectedTab: null
    }
  },
  computed: {
    ...mapState(['isCollapsed', 'patient', 'currentUser']),
    patientHeader() {
      return this.$route.matched.some(({ name }) => name === 'patient-main')
    }
  },
  watch: {
    patientHeader(newValue, oldValue) {
      if (this.patientHeader) {
        const patientID = this.$route.path.split('/')[2]
        this.getPatientInfo(patientID)
      }
    },
    '$route.path' () {
      this.setTab()
    }
  },
  mounted () {
    this.setTab()
    if (this.patientHeader) {
      const patientID = this.$route.path.split('/')[2]
      this.getPatientInfo(patientID)
    }
  },
  methods: {
    ...mapActions(['toggleCollapse', 'getPatientInfo', 'removeToken']),
    selectTab (tabIndex) {
      this.selectedTab = tabIndex
    },
    setTab () {
      if (this.pageNames.indexOf(this.$route.name) !== -1) {
        this.selectedTab = this.pageNames.indexOf(this.$route.name)
      }
    },
    async logout () {
      // console.log(axios.defaults.headers.common)
      await axios.post(process.env.VUE_APP_API_URL + '/token/logout')
      axios.defaults.headers.common.Authorization = ''
      // console.log(axios.defaults.headers.common)

      localStorage.removeItem('token')
      localStorage.setItem('isAuthenticated', false)
      this.removeToken()

      this.$router.push('/login')
    },
    getProfilePic (user) {
      if (!user.profilePic) {
        return defaultPic(user)
      } else {
        if (user.profilePic.includes('http')) {
          return user.profilePic
        } else {
          return publicAssetUrl(user.profilePic)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.background-main {
  height: 100vh;
  overflow: hidden;
  display: flex;
}
::v-deep .menu {
  list-style-type: none;
  color: #c4c4c4;
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  height: 82.5%;
  .menu-item {
    .menu-item-text {
      text-align: left;
      transition: font-size 0.3s ease-out;
      color: #c4c4c4;
    }
    img, svg {
      display: none;
      margin: 0 auto;
      outline: none;
    }
    padding-bottom: 1.25rem;
    &:hover {
      .menu-item-text {
        color: white;
      }
      cursor: pointer;
      .menu-icon{
        // filter: brightness(100) saturate(100%);
        * {
          fill: white;
        }
      }
    }
  }
  .active{
    color: white;
    * {
      fill: white;
    }
    .menu-item-text {
      color: white;
    }
  }
}

.font-small {
  padding: 0;
  margin: 0;
  margin-top: 45px !important;
  .menu-item {
    text-align: center;
    .menu-item-text{
      display: none;
      font-size: 0.625rem;
    }
    img, svg {
      display: block;
      margin-bottom: 5px;
      width: 25px;
    }
  }
}

.main-view-wrapper {
  background: var(--background);
  width: 100%;
  header {
      // height: 70px;
      display: flex;
      background: white;
      padding: 9px 15px;
      width: 100%;
      z-index: 5;
      .user-options {
        margin-left: auto;
        display: flex;
        align-items: center;
        .header-profile-pic {
          width: 35px;
          height: 35px;
          background: var(--medium-gray);
          border-radius: 50%;
          margin-right: 0.625rem;
          overflow: hidden;
          .profilePic {
            width: inherit;
            object-fit: contain;
          }
        }
      }
      .button-link {
        display: flex;
        .add-button {
          display: flex;
          border: none;
          padding: 0 10px;
          background-color: #2785FF;
          background-color: var(--primary-accent-light);
          border-radius: 50px;
          width: max-content;
          align-items: center;
          margin-right: 10px;
          .add-button-text {
            // border: 1px solid yellow;
            color: #FFFFFF;
            width: 100%;
            margin: 0 10px;
            font-size: 0.875rem;
          }
        }
      }
    }
  .main-view {
    width: 100%;
    overflow-y: auto;
    height: 100vh;
    .toast-container {
      width: fit-content !important;
      position: absolute;
      right: 15px;
      bottom: 15px;
    }
  }
}

::v-deep .button-logo {
  display: flex;
  filter: invert(100);
  fill: white;
}

.sidepanel-wrapper {
  transition: 0.3s ease-out;
  // width: 270px;
}
.sidepanel {
  background: #1a1a1a;
  width: 270px;
  transition: 0.3s ease-out;
  height: inherit;
  overflow: hidden;
  .logo {
    padding: 23px 0px 12px 15px;
    min-width: 270px;
    img {
      width: 35px;
      object-fit: contain;
    }
    .logo-text {
      margin-left: 12px;
      font-size: 18px;
      color: #fff;
      transition: 0.1s ease-out;
    }
    .hide {
      opacity: 0;
      pointer-events: none;
    }
  }
  .toggle {
    background: transparent;
    outline: none;
    border: none;
    box-shadow: none;
    width: fit-content;
    margin: 0 auto;
    img {
      width: 14px;
      object-fit: contain;
    }
  }
}

.padding-sides {
  padding: 0px 20px 0px;
  overflow: auto;
  height: calc(100vh - 70px);
}

.mask {
  position: absolute;
  top: 53px;
  right: 0;
  width: calc(100% - 270px);
  height: calc(100vh - 53px);
  box-shadow: inset 0 1px 8px 0px rgb(0 0 0 / 25%);
  transition: width 0.3s ease-out;
  pointer-events: none;
}

.change-width {
  width: calc(100% - 85px);
}

.change-height {
  height: calc(100% - 218px);
  top: 218px;
}

.isCollapsed {
  width: 85px;
}

</style>
